import { type MouseEventHandler } from "react"
import {
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
} from "./iconOutline"

export type PanelToggleButtonProps = {
  panelVisible: boolean
  /**
   * The direction that the panel collapses towards. For example, if the panel
   * collapses towards the right, indicate "right" and the icons will be displayed
   * correctly based on the `panelVisible` property.
   */
  direction: "right" | "bottom" | "left" | "top"
  onClick: MouseEventHandler<HTMLButtonElement>
}

export function PanelToggleButton({
  panelVisible,
  direction,
  onClick,
}: PanelToggleButtonProps) {
  return (
    <button
      className="panel-toggle-button"
      data-visible={panelVisible}
      data-direction={direction}
      type="button"
      onClick={onClick}
    >
      {direction === "right" &&
        (panelVisible ? <ChevronRight /> : <ChevronLeft />)}
      {direction === "bottom" &&
        (panelVisible ? <ChevronDown /> : <ChevronUp />)}
      {direction === "left" &&
        (panelVisible ? <ChevronLeft /> : <ChevronRight />)}
      {direction === "top" && (panelVisible ? <ChevronUp /> : <ChevronDown />)}
    </button>
  )
}
